export default {"src":"/_next/static/media/call-icon.aa1a63a4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};